import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';
import * as g from '../../castle-kit-grounds';

/**
 * WEST CLOISTER (Западная галерея) — a covered arcade: the open-air, tall-and-narrow shaded transit
 * spine that runs the west flank of Castle Hearthhold. It is a WALKWAY, kept deliberately SPARE and
 * airy — the long central run stays empty so the eye (and the duck) flows straight through.
 *
 * Composition: the HERO is the rhythmic march of arched PILLARS down the EAST wall — the only motif
 * repeated, so the colonnade reads at a glance. The WEST wall is dressed only at its midpoint: a pair
 * of heraldic BANNERS frame a shaded garden BENCH (the rest-stop / sit anchor), with a single topiary
 * and fern as a quiet green accent and a warm lamppost pooling light over the gather-spot. A second
 * lamppost lights the far south end. Everything else is intentional EMPTY FLOOR.
 *
 * Geometry: zone (800,760) 380×1280 → centre (990,1400). Doors E (y1040/y1680), W (y970/y1440/y1870),
 * N (x990), S (x990) are kept clear — set-dressing hugs the two long walls, the central vertical
 * walkway (x≈990) stays open end to end.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art, f } = ctx;

  // ── HERO: the arched COLONNADE down the EAST wall — the one repeated rhythm of the covered walk. ──
  for (const py of [900, 1200, 1500, 1800]) {
    place(ctx, kit.pillar(art), 1150, py);
  }

  // ── CENTRE ANCHOR: a carved stone STATUE at the corridor's mid-point gives the long walk a visual focus
  //    (instead of a vertical sprinkle); the rest BENCH (sit anchor @870,1240, kept exactly) sits just above
  //    it, the two framed by a matched pair of heraldic BANNERS. ──
  place(ctx, kit.banner(art, 0x8a2f2f, 110), 860, 1080);
  place(ctx, g.gardenBench(art, 72), 870, 1240);
  place(ctx, kit.statue(art), 870, 1420);
  place(ctx, kit.banner(art, 0x8a2f2f, 110), 860, 1620);

  // ── A single clipped green accent, set clear of the banner so each has its own breathing room. ──
  place(ctx, g.topiary(art, 'cone'), 940, 1720);
  void f;

  // ── POOL LIGHT: period BRAZIERS (not street-lamps) — one warms the bench/statue gather-spot, one the
  //    far south end of the covered walk. ──
  place(ctx, kit.brazier(art), 870, 1340);
  place(ctx, kit.brazier(art), 870, 1860);
};

export default decorate;
